<template>
  <div>
    <b-navbar
      toggleable="lg"
      variant="light"
      align="end"
      class="nav mt-4 mb-4 shadow"
    >
      <b-navbar-toggle target="nav-collapse" />
      <b-collapse id="nav-collapse" is-nav align="end">
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
            <b-nav-item
              @click="setStatus('preRegistration')"
              :active="status == 'preRegistration'"
            >
              Pre registration
            </b-nav-item>
            <b-nav-item
              @click="setStatus('inReview')"
              :active="status == 'inReview'"
            >
              In review
            </b-nav-item>
            <b-nav-item
              @click="setStatus('active')"
              :active="status == 'active'"
            >
              Active
            </b-nav-item>
            <b-nav-item
              @click="setStatus('rejected')"
              :active="status == 'rejected'"
            >
              Rejected
            </b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: "preRegistration",
    };
  },
  created() {
    this.$emit("set-status", this.status);
  },
  methods: {
    setStatus(status) {
      this.status = status;
      this.$emit("set-status", status);
    },
  },
};
</script>

<style>
</style>